import { render, staticRenderFns } from "./PremiumTrialAlert.vue?vue&type=template&id=2e134d9d&"
import script from "./PremiumTrialAlert.vue?vue&type=script&lang=js&"
export * from "./PremiumTrialAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports